/* Canvia: opt-in, first-party category relevance. No network calls or third-party pixels.
   Server markup/order is always the fallback. Older gift affinity is intentionally
   ignored until an explicit Shopify preferences consent ('yes') AND allowed()=true. */
(() => {
 'use strict';
 const KEY='canvia-gift-interest-v1', AGE=30*86400000, states=new WeakMap();
 let permitted=false;
 const TERMS={
  hair:/\b(hair|scalp|shampoo|conditioner|frizz|batana|cheveux|cheveu|capillaire|cuir chevelu)\b/,
  makeup:/\b(makeup|cosmetic|lipstick|foundation|eyeshadow|mascara|blush|concealer|maquillage|levres|rouge a levres|fond de teint|fard)\b/,
  body:/\b(body|bath|shower|hand|massage|lotion|corps|bain|douche|mains|corporel)\b/,
  skincare:/\b(skin|skincare|face|facial|serum|retinol|retinal|cream|moisturiz|cleanser|acne|vitamin c|peau|visage|creme|hydrat|nettoyant|ridules)\b/
 };
 const normalize=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[_-]/g,' ').replace(/\s+/g,' ').trim();
 const category=s=>Object.keys(TERMS).find(k=>TERMS[k].test(normalize(s)))||'';
 const concern=s=>{
  const v=normalize(s);
  if(/\b(acne|blemish|pimple|bouton|imperfection|salicylic)\b/.test(v))return 'acne';
  if(/\b(dry|dehydrat|sec|seche|hydration|hydrat)\b/.test(v))return 'dry';
  if(/\b(sensitive|sensibl|soothing|apaisant)\b/.test(v))return 'sensitive';
  if(/\b(bright|vitamin c|glow|eclat|tern)\b/.test(v))return 'brighten';
  if(/\b(repair|damag|breakage|repar|abim|cassure)\b/.test(v))return 'repair';
  return '';
 };
 const explicit=()=>{
   const p=window.Shopify?.customerPrivacy;
   try{return p?.preferencesProcessingAllowed?.()===true && p?.currentVisitorConsent?.()?.preferences==='yes';}
   catch(_){return false;}
 };
 const purge=()=>{try{localStorage.removeItem(KEY);}catch(_){}};
 function read(){
   if(!permitted)return null;
   try{
     const x=JSON.parse(localStorage.getItem(KEY)||'null');
     if(!x||!Number.isFinite(x.at)||x.at>Date.now()||Date.now()-x.at>AGE)return null;
     if(!TERMS[x.category] && !['me','gift'].includes(x.shoppingFor))return null;
     return x;
   }catch(_){return null;}
 }
 function save(newInfo){
   if(!permitted)return;
   const prior=read()||{};
   const record={category:newInfo.category||prior.category||'',concern:newInfo.concern||prior.concern||'',
     shoppingFor:newInfo.shoppingFor||prior.shoppingFor||'',source:newInfo.source||prior.source||'',at:Date.now()};
   if(!TERMS[record.category]&&!['me','gift'].includes(record.shoppingFor))return;
   try{localStorage.setItem(KEY,JSON.stringify(record));}catch(_){}
   reorderAll();
 }
 const customerOrders=()=>{
   if(!permitted)return new Set();
   try{const el=document.querySelector('[data-canvia-purchased-hints]');const a=JSON.parse(el?.textContent||'[]');return new Set(Array.isArray(a)?a.slice(0,80).filter(x=>/^[a-z0-9-]{1,130}$/i.test(x)):[]);}
   catch(_){return new Set();}
 };
 const info=el=>{
   const card=el.matches?.('[data-canvia-product-handle]')?el:el.querySelector?.('[data-canvia-product-handle]');
   return card?.dataset || {};
 };
 const score=(el,x,purchased)=>{
   const d=info(el),tags=normalize(d.canviaTags||el.dataset.canviaGiftTags),type=normalize(d.canviaType||el.dataset.canviaGiftType),
     title=normalize(d.canviaTitle||el.dataset.canviaGiftTitle),handle=d.canviaProductHandle;
   let result=0;const all=tags+' '+type+' '+title;
   if(x?.category){
     result+=TERMS[x.category]?.test(tags)?18:TERMS[x.category]?.test(type)?12:TERMS[x.category]?.test(title)?6:0;
   }
   if(x?.concern && all.includes(x.concern))result+=7;
   if(x?.shoppingFor==='gift' && /gift|set|kit|bundle|cadeau|coffret/.test(all))result+=6;
   if(x?.shoppingFor==='hair' && TERMS.hair.test(all))result+=11;
   if(x?.shoppingFor==='skincare' && TERMS.skincare.test(all))result+=11;
   if(x?.shoppingFor==='me' && /refill|recharge|subscription/.test(all))result+=2;
   if(purchased.has(handle)){
     result-=24;
   }else if(purchased.size && /format[ -]refill|refill|recharge/.test(all)){
     result+=3;
   }
   // Only a public merchant-declared market tag can inform country relevance.
   const country=document.body.dataset.canviaCountry;
   if(country==='US' && /(^|\|)(market-us|country-us|us-relevant)(\||$)/.test(tags.replace(/ /g,'-')))result+=3;
   if(country==='CA' && /(^|\|)(market-ca|country-ca|ca-relevant)(\||$)/.test(tags.replace(/ /g,'-')))result+=3;
   return result;
 };
 function restore(container){
   const baseline=states.get(container);
   if(!baseline)return;
   if(baseline.some(el=>el.parentElement!==container))return;
   baseline.forEach(el=>container.appendChild(el));
   if(container.matches('[data-canvia-gift-track],.related-products__track')){
     container.scrollLeft=0;requestAnimationFrame(()=>{container.scrollLeft=0;});
   }
 }
 function containerChildren(container){
   if(container.matches('[data-canvia-gift-track]'))return [...container.children].filter(x=>x.classList.contains('canvia-december-gifts__product'));
   if(container.matches('[data-canvia-reorder="upsell"]'))return [...container.children].filter(x=>x.matches('[data-canvia-upsell-item]'));
   return [...container.children].filter(x=>x.querySelector('[data-canvia-product-handle]'));
 }
 function eligible(container){
   if(!permitted)return false;
   if(container.dataset.canviaReorder==='collection'){
     if(new URLSearchParams(location.search).has('sort_by'))return false;
     if(container.dataset.canviaDefaultSort!=='manual')return false;
     const page=Number(new URLSearchParams(location.search).get('page')||1);
     if(page!==1)return false;
   }
   return true;
 }
 function arrange(container){
   const children=containerChildren(container);
   if(children.length<2)return;
   if(!states.has(container))states.set(container,children);
   else if(states.get(container).some(el=>el.parentElement!==container))states.set(container,children);
   const baseline=states.get(container);
   restore(container);
   if(!eligible(container))return;
   const x=read(),purchased=customerOrders();
   const country=document.body.dataset.canviaCountry;
   if(!x && !purchased.size && country!=='CA' && country!=='US')return;
   const ranks=baseline.map((el,index)=>({el,index,n:score(el,x,purchased)}));
   if(!ranks.some(v=>v.n!==ranks[0].n))return;
   ranks.sort((a,b)=>b.n-a.n||a.index-b.index);
   ranks.forEach(v=>container.appendChild(v.el));
   if(container.matches('[data-canvia-gift-track],.related-products__track')){
     container.scrollLeft=0;requestAnimationFrame(()=>{container.scrollLeft=0;});
   }
 }
 function reorderAll(scope=document){
   const selectors='[data-canvia-gift-track],[data-canvia-reorder]';
   if(scope.matches?.(selectors))arrange(scope);
   scope.querySelectorAll?.(selectors).forEach(arrange);
 }
 const sync=()=>{
   const now=explicit();
   if(permitted && !now){permitted=false;purge();}
   else if(!now){permitted=false;purge();}
   else permitted=true;
   reorderAll();
 };
 function setupConsent(){
   document.addEventListener('visitorConsentCollected',sync);
   if(typeof window.Shopify?.loadFeatures==='function'){
     window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)sync();});
   }
   sync();
 }
 // The input in the standard Beauty Finder and chips remain ordinary search
 // controls without consent. Only optional lasting affinity is consent-gated.
 document.addEventListener('submit',event=>{
   if(!event.target.matches?.('.canvia-discovery__form'))return;
   const query=event.target.querySelector('input[name="q"]')?.value||'';
   save({category:category(query),concern:concern(query),source:'finder'});
 },true);
 document.addEventListener('click',event=>{
   const chip=event.target.closest?.('[data-canvia-discovery-query]');
   if(chip)save({category:category(chip.dataset.canviaDiscoveryQuery),concern:concern(chip.dataset.canviaDiscoveryQuery),source:'finder'});
   const choice=event.target.closest?.('[data-canvia-shopping-for]');
   if(choice){
     const value=choice.dataset.canviaShoppingFor;
     if(!['me','gift','skincare','hair'].includes(value))return;
     const group=choice.closest('[data-canvia-shopping-choices]');
     group?.querySelectorAll('[data-canvia-shopping-for]').forEach(button=>button.setAttribute('aria-pressed',String(button===choice)));
     if(!permitted){
       const status=group?.querySelector('[data-canvia-preferences-note]');
       if(status)status.hidden=false;
       return;
     }
     save({shoppingFor:value,category:['skincare','hair'].includes(value)?value:'',source:'self'});
   }
 },true);
 const viewed=document.querySelector('[data-canvia-gift-viewed]');
 const saveViewed=()=>{
   if(!viewed||!permitted)return;
   const v=[viewed.dataset.canviaViewedTags,viewed.dataset.canviaViewedType,viewed.dataset.canviaViewedTitle].join(' ');
   save({category:category(v),concern:concern(v),source:'viewed'});
 };
 function giftNavigation(section){
   const row=section.querySelector('[data-canvia-gift-track]');
   if(!row||row.dataset.canviaControls)return;
   row.dataset.canviaControls='true';
   const prev=section.querySelector('[data-canvia-gift-prev]'),next=section.querySelector('[data-canvia-gift-next]');
   const update=()=>{
     if(prev)prev.disabled=row.scrollLeft<=2;
     if(next)next.disabled=row.scrollLeft>=row.scrollWidth-row.clientWidth-2;
   };
   prev?.addEventListener('click',()=>row.scrollBy({left:-row.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
   next?.addEventListener('click',()=>row.scrollBy({left:row.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
   row.addEventListener('scroll',update,{passive:true});update();
 }
 function init(scope=document){
   const sec=scope.matches?.('[data-canvia-gifts]')?[scope]:[...scope.querySelectorAll?.('[data-canvia-gifts]')||[]];
   sec.forEach(giftNavigation);
   reorderAll(scope);
 }
 document.addEventListener('canvia:recommendations-loaded',e=>init(e.detail?.root||document));
 document.addEventListener('shopify:section:load',e=>init(e.target));
 if(document.readyState==='loading'){
   document.addEventListener('DOMContentLoaded',()=>{setupConsent();saveViewed();init();},{once:true});
 }else{setupConsent();saveViewed();init();}
 // Old browser-local interests remain inert until explicit preferences consent.
})();
